import { h } from 'preact'
import SubCategories from '@features/elastic/subCategories/SubCategories'

export default function ArchiveHeader({
	name,
	description,
	subCategories,
	searchText,
	displaySearchText,
	imageUrl,
	imageAlt,
}) {
	const showSubCategories = subCategories && subCategories.length > 0
	const showImage = imageUrl && !!imageUrl.trim()

	return (
		<header className="page-title">
			<div className="page-title__left">
				{name && <h1>{name}</h1>}
				{description && (
					<div className="archive__description" dangerouslySetInnerHTML={{ __html: description }} />
				)}
				{showSubCategories && <SubCategories categories={subCategories} />}
				{displaySearchText && <span className="archive__was-searched">{searchText}</span>}
			</div>

			{showImage && (
				<div className="page-title__right">
					<img className="archive-image" src={imageUrl} alt={imageAlt} />
				</div>
			)}
		</header>
	)
}
